/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 10:02:20
 * @LastEditTime: 2019-09-26 20:50:09
 * @LastEditors: Please set LastEditors
 */
import { getStore } from '@/utils'
// console.log('node_env', process.env.NODE_ENV)
// console.log('node_env', process.env.VUE_APP_DOMAIN_ENV)
const protocolStr = document.location.protocol
const mainDomain = 'api.ececloud.cn'

let domainMap = {
  development: `${protocolStr}//${mainDomain}`,
  test: `${protocolStr}//test${mainDomain}`,
  // test: `${protocolStr}//test.vip.ececloud.cn`,
  // test: `http://192.168.0.89:8080`,
  beta: `${protocolStr}//${mainDomain}`,
  production: `${protocolStr}//${mainDomain}`,
  pre: `${protocolStr}//pre.${mainDomain}`
}
// @ts-ignore
const domain = domainMap[process.env.VUE_APP_DOMAIN_ENV]
export default {
  BASE_API: `${domain}`,
  HEALTH: `${domain}/api-health/`
}
